/* mythos-header.js — comportement du mega-menu Mythos (commutation des facettes + panneau description).
   Markup : snippets/mega-menu.liquid. Styles : assets/mythos-header.css. Idempotent. */
(function () {
  function updateDescPanel(mega, link) {
    var panel = mega.querySelector('[data-desc-panel]');
    if (!panel) return;
    mega.querySelectorAll('.mega-list a').forEach(function (x) { x.classList.remove('is-active'); });
    link.classList.add('is-active');
    var nm = panel.querySelector('.lm-desc__name');
    if (nm) nm.textContent = (link.getAttribute('data-name') || link.textContent).trim();
    var tx = panel.querySelector('.lm-desc__text');
    if (tx) tx.textContent = link.getAttribute('data-desc') || '';
    var cta = panel.querySelector('.lm-desc__link');
    if (cta) {
      var ctaTxt = link.getAttribute('data-cta');
      if (ctaTxt) { cta.textContent = ctaTxt; cta.href = link.getAttribute('href') || '#'; cta.hidden = false; }
      else { cta.hidden = true; }
    }
    var g = link.querySelector('.stone, .metal');
    var holder = panel.querySelector('.lm-desc__gem');
    if (holder) holder.innerHTML = g ? g.outerHTML : '';
  }

  // Colonne produits (.mega-products) : 2 cartes par collection, demandées à
  // sections/mega-menu-preview.liquid (GET <url collection>?section_id=mega-menu-preview)
  // au moment où on en a besoin, puis gardées en cache pour la visite. Le Liquid ne
  // rend plus aucun produit dans le menu : 33 collections × 2 cartes à chaque page
  // faisaient dépasser le budget de rendu Shopify sur .com/.co.uk/.es.
  var previewCache = {};
  var previewReady = {};
  var STORE_KEY = 'mythos-preview:';

  function storedPreview(url) {
    try { return sessionStorage.getItem(STORE_KEY + url); } catch (e) { return null; }
  }

  function fetchPreview(url) {
    if (!url) return Promise.resolve('');
    if (previewCache[url]) return previewCache[url];
    var stored = storedPreview(url);
    if (stored !== null) { previewReady[url] = stored; previewCache[url] = Promise.resolve(stored); return previewCache[url]; }
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    previewCache[url] = fetch(url + sep + 'section_id=mega-menu-preview', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var box = document.createElement('div');
        box.innerHTML = html;
        var cards = box.querySelectorAll('a.mc');
        var out = '';
        cards.forEach(function (a) { out += a.outerHTML; });
        try { sessionStorage.setItem(STORE_KEY + url, out); } catch (e) { /* quota ou navigation privée : on garde le cache mémoire */ }
        previewReady[url] = out;
        return out;
      })
      .catch(function () { delete previewCache[url]; return ''; });
    return previewCache[url];
  }

  // File unique, 2 requêtes à la fois : le panneau se remplit dans l'ordre demandé,
  // sans rafale sur le storefront.
  var queue = [];
  var running = 0;
  function pump() {
    while (running < 2 && queue.length) {
      running += 1;
      fetchPreview(queue.shift()).then(function () { running -= 1; pump(); });
    }
  }
  function prefetchList(urls, front) {
    var fresh = urls.filter(function (u, i) { return u && urls.indexOf(u) === i && !previewCache[u] && queue.indexOf(u) === -1; });
    queue = front ? fresh.concat(queue) : queue.concat(fresh);
    pump();
  }

  function megaProductsEl(mega) {
    var aux = mega.querySelector('[data-aux]');
    return aux ? aux.querySelector('.mega-products') : null;
  }

  function showProducts(mega, url) {
    var c = megaProductsEl(mega);
    if (!c) return;
    mega._previewWanted = url;
    if (!url) { c.innerHTML = ''; return; }
    // Avant le premier survol de l'entrée de menu, on note seulement ce qu'il faudra
    // afficher : l'init au chargement ne doit déclencher aucune requête.
    if (!mega._armed) return;
    if (previewReady[url] === undefined) {
      // Pas encore là : on montre les 2 produits L1 (préchargés au repos) plutôt
      // qu'une colonne vide le temps de la requête.
      var dflt = c.getAttribute('data-preview-url');
      if (dflt && dflt !== url && previewReady[dflt] !== undefined) c.innerHTML = previewReady[dflt];
    }
    fetchPreview(url).then(function (html) {
      if (mega._previewWanted !== url) return;
      c.innerHTML = html;
    });
  }

  function restoreDefaultProducts(mega) {
    var c = megaProductsEl(mega);
    showProducts(mega, c ? c.getAttribute('data-preview-url') : '');
  }

  function updateProducts(mega, link) {
    showProducts(mega, link.getAttribute('data-preview-url'));
  }

  function switchFacet(mega, facet) {
    var key = facet.getAttribute('data-facet');
    var kind = facet.getAttribute('data-kind');
    mega.querySelectorAll('.mega-facet[data-facet]').forEach(function (x) { x.classList.remove('is-active'); });
    mega.querySelectorAll('.mega-list').forEach(function (x) { x.classList.remove('is-active'); });
    facet.classList.add('is-active');
    var list = mega.querySelector('.mega-list[data-list="' + key + '"]');
    if (list) list.classList.add('is-active');

    var aux = mega.querySelector('[data-aux]');
    var panel = mega.querySelector('[data-desc-panel]');
    // Panneau "discours" seulement quand data-panel=1 (Joaillerie pierres/métal + La Marque) ;
    // sinon on garde la mise en page photos (produits + visuel). Collections = pleine largeur.
    var showPanel = facet.getAttribute('data-panel') === '1';
    var showAux = (kind !== 'collections' && kind !== 'duo') && !showPanel;
    if (aux) aux.hidden = !showAux;
    if (panel) {
      panel.hidden = !showPanel;
      var eb = panel.querySelector('.lm-desc__eyebrow');
      if (eb && showPanel) {
        var lbl = panel.getAttribute('data-eb-' + kind);
        if (lbl) eb.textContent = lbl;
      }
    }
    if (showPanel && list) {
      var first = list.querySelector('a[data-desc]') || list.querySelector('a');
      if (first) updateDescPanel(mega, first);
    }
    // Colonne produits : sur une facette à previews (pierre), afficher le 1er par défaut ;
    // sinon restaurer les 2 produits L1 d'origine (évite un état produits "collé").
    if (showAux) {
      var firstPrev = list ? list.querySelector('a[data-has-preview]') : null;
      if (firstPrev) updateProducts(mega, firstPrev);
      else restoreDefaultProducts(mega);
      if (list && mega._armed) {
        var urls = [];
        list.querySelectorAll('a[data-preview-url]').forEach(function (a) { urls.push(a.getAttribute('data-preview-url')); });
        prefetchList(urls, true);
      }
    }
    // Mode de mise en page (réplique des grilles par facette de la maquette)
    var inner = mega.querySelector('.mythos-mega__inner');
    if (inner) {
      var mode = 'aux';
      if (kind === 'collections') {
        mode = 'gallery';
      } else if (kind === 'duo') {
        mode = 'duo';
      } else if (showPanel) {
        if (list && list.classList.contains('gem-cols')) {
          mode = 'panel-palette';      // Joaillerie pierres : liste large + panneau 330
        } else if (kind === 'pages') {
          mode = 'panel-split';        // La Marque : liste + panneau partagent
        } else {
          mode = 'panel-list';         // Métal : liste étroite + panneau large
        }
      }
      inner.setAttribute('data-mode', mode);
    }
  }

  function initMega(mega) {
    if (mega.dataset.mythosInit) return;
    mega.dataset.mythosInit = '1';
    // Les produits L1 et la première preview de la facette active partent dès que
    // le curseur entre dans l'entrée de menu, avant même l'ouverture du panneau.
    // Dès que le curseur entre dans l'entrée de menu : la facette active d'abord,
    // puis toutes les previews de ce panneau en tâche de fond.
    var host = mega.parentElement || mega;
    host.addEventListener('mouseenter', function () {
      mega._armed = true;
      showProducts(mega, mega._previewWanted || '');
      var urls = [];
      mega.querySelectorAll('.mega-list.is-active a[data-preview-url]').forEach(function (a) { urls.push(a.getAttribute('data-preview-url')); });
      mega.querySelectorAll('.mega-list a[data-preview-url]').forEach(function (a) { urls.push(a.getAttribute('data-preview-url')); });
      prefetchList(urls, true);
    }, { once: true });
    mega.querySelectorAll('.mega-facet[data-facet]').forEach(function (f) {
      f.addEventListener('mouseenter', function () { switchFacet(mega, f); });
      f.addEventListener('click', function (e) { e.preventDefault(); switchFacet(mega, f); });
    });
    mega.querySelectorAll('.mega-list a[data-desc]').forEach(function (link) {
      link.addEventListener('mouseenter', function () { updateDescPanel(mega, link); });
    });
    mega.querySelectorAll('.mega-list a[data-has-preview]').forEach(function (link) {
      link.addEventListener('mouseenter', function () { updateProducts(mega, link); });
    });
    var active = mega.querySelector('.mega-facet.is-active[data-facet]') || mega.querySelector('.mega-facet[data-facet]');
    if (active) switchFacet(mega, active);
  }

  function init() {
    var megas = document.querySelectorAll('.mega-menu.mythos-mega');
    megas.forEach(initMega);
    // Les 2 produits L1 de chaque entrée (ce qu'on voit à l'ouverture) partent quand
    // la page est au repos, une fois par session : à l'ouverture du menu ils sont là.
    var idle = window.requestIdleCallback || function (cb) { setTimeout(cb, 1500); };
    function warmDefaults() {
      idle(function () {
        var urls = [];
        megas.forEach(function (mega) {
          var c = megaProductsEl(mega);
          if (c) urls.push(c.getAttribute('data-preview-url'));
        });
        prefetchList(urls);
      });
    }
    if (document.readyState === 'complete') warmDefaults();
    else window.addEventListener('load', warmDefaults);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
